import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookingTypesComponent } from '../components/booking-types';
import { BookingTypeListComponent } from '../components/booking-types/booking-type-list/booking-type-list.component';
import { BookingTypeEditComponent } from '../components/booking-types/booking-type-edit/booking-type-edit.component';
import { AuthGuard } from '@fry/lib/guards';
import { BookingTypeResolver, VenueResolver } from '../lib';
import { BookingTypeCreateComponent } from '../components/booking-types/booking-type-create/booking-type-create.component';
import {
  BookingItemListComponent,
  BookingItemOptionViewComponent,
  BookingItemsComponent,
} from '../components/booking-items';
import { BookingItemResolver } from '../lib/booking-items';

import { VenuesComponent } from '../components/venues/venues/venues.component';
import { VenueListComponent } from '../components/venues/venue-list/venue-list.component';
import { VenueCreateComponent } from '../components/venues/venue-create/venue-create.component';
import { VenueEditComponent } from '../components/venues/venue-edit/venue-edit.component';
import { BookingItemPreviewComponent } from '../components/booking-items/booking-item-preview/booking-item-preview.component';
import { BookingAvailableItemsListComponent } from '../components/bookings/booking-available-items/booking-available-items-list.component';
import { BookingListComponent } from '../components/bookings/booking-list/booking-list.component';
import { BookingEditComponent } from '../components/bookings/booking-edit/booking-edit.component';
import { BookingResolver } from '../lib/bookings/booking.resolver';
import { UserBookingListComponent } from '../components/bookings/user-booking-list/user-booking-list.component';
import { UserBookingResolver } from '../lib/bookings/user-booking.resolver';
import { BookingOptionResolver } from '../lib/booking-items/booking-option.resolver';
import { BookingManageComponent } from '../components/bookings/booking-manage/booking-manage.component';
import { BookingItemIntegrationComponent } from '../components/booking-items/booking-item-integration/booking-item-integration.component';
import { EditorBookingItemTreeCreateComponent } from '../booking-item-editor/editor-booking-item-tree-create/editor-booking-item-tree-create.component';
import { EditorBookingItemTreeEditComponent } from '../booking-item-editor/editor-booking-item-tree-edit/editor-booking-item-tree-edit.component';
import { TranslationFormComponent } from '../translation-editor/translation-form/translation-form.component';
import { TranslationSelectorComponent } from '../translation-editor/translation-selector/translation-selector.component';
import { BookingApplyComponent } from '../components/bookings/booking-apply/booking-apply.component';
import { BookingAvailableListComponent } from '../components/bookings/booking-available-items/booking-available-list.component';


const routes: Routes = [
  {
    path: 'booking-types',
    component: BookingTypesComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['bookingTypes.view'],
    },
    children: [
      {
        path: '',
        component: BookingTypeListComponent
      },
      {
        path: 'add',
        component: BookingTypeCreateComponent,
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: ':id/edit',
        component: BookingTypeEditComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          bookingType: BookingTypeResolver
        }
      }
    ]
  },
  {
    path: 'booking-items',
    component: BookingItemsComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['bookingItems.view'],
    },
    children: [
      {
        path: '',
        component: BookingItemListComponent
      },
      {
        path: 'add',
        component: EditorBookingItemTreeCreateComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
          requiredPermissions: ['bookingItems.edit'],
        },
      },
      {
        path: ':id/edit',
        component: EditorBookingItemTreeEditComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
          requiredPermissions: ['bookingItems.edit'],
        },
        canDeactivate: [
          // UnsavedGuard
        ],
        resolve: {
          bookingItem: BookingItemResolver
        }
      },
      {
        path: ':id/view',
        component: BookingItemOptionViewComponent,
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: ':id/integration',
        component: BookingItemIntegrationComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          bookingItem: BookingItemResolver
        }
      },
      // {
      //   path: ':id/view/:boid',
      //   component: BookingListComponent,
      //   canActivate: [
      //     AuthGuard
      //   ],
      //   resolve: {
      //     bookingOption: BookingOptionResolver
      //   }
      // },
      {
        path: ':id/view/:boid',
        component: BookingItemOptionViewComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {}
      },
      {
        path: ':id/preview',
        component: BookingItemPreviewComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          bookingItem: BookingItemResolver
        }
      }
    ]
  },
  {
    path: 'venues',
    component: VenuesComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['venues.view'],
    },
    children: [
      {
        path: '',
        component: VenueListComponent
      },
      {
        path: 'add',
        component: VenueCreateComponent,
        canActivate: [
          AuthGuard
        ]
      },
      {
        path: ':id/edit',
        component: VenueEditComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          venue: VenueResolver
        }
      }
    ]
  },
  {
    path: 'bookings',
    canActivate: [
      AuthGuard
    ],
    data: {
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: UserBookingListComponent,
        canActivate: [
          AuthGuard
        ],
      },
      {
        path: 'available',
        component: BookingAvailableListComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [
          AuthGuard
        ],
      },
      {
        path: 'available-old',
        component: BookingAvailableItemsListComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [
          AuthGuard
        ],
      },
      {
        path: 'apply/:bid/:boid',
        component: BookingApplyComponent,
        canActivate: [
          AuthGuard
        ],
      },
      {
        path: ':id/edit',
        component: BookingEditComponent,
        canActivate: [
          AuthGuard
        ],
        resolve: {
          booking: UserBookingResolver
        }
      },
      {
        path: ':id/manage',
        component: BookingManageComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
          requiredPermissions: ['bookings.manage'],
        },
        resolve: {
          booking: UserBookingResolver
        }
      }
    ]
  },
  {
    path: 'all-bookings',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: BookingListComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
        },
       },
      {
        path: ':id/edit',
        component: BookingEditComponent,
        canActivate: [
          AuthGuard
        ],
        data: {
        },
        resolve: {
          booking: BookingResolver
        }
      }
    ]
  },
  {
    path: 'users/:user/all-bookings',
    component: BookingListComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['bookings.view'],
      userParamArg: 'user'
    },
    resolve: { },
  },
  {
    path: 'users/:user/available',
    component: BookingAvailableListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [
      AuthGuard
    ],
  },
  {
    path: 'users/:user/apply/:bid/:boid',
    component: BookingApplyComponent,
    canActivate: [
      AuthGuard
    ],
  },
  {
    path: 'users/:user/available-old',
    component: BookingAvailableItemsListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [
      AuthGuard
    ],
  },
  {
    path: 'translation/:docType/:objectId',
    component: TranslationSelectorComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['translations.view'],
    }
  },
  {
    path: 'translation/:docType/:objectId/:languageCode',
    component: TranslationFormComponent,
    canActivate: [
      AuthGuard
    ],
    data: {
      requiredPermissions: ['translations.view'],
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
  providers: [
    BookingTypeResolver,
    BookingItemResolver,
    BookingOptionResolver,
    VenueResolver,
    BookingResolver,
    UserBookingResolver,
  ]
})
export class BookingRoutingModule { }
